import React, { useState } from "react";
import PayoutDetailsModal from "./PayoutDetailsModal"; // Import the modal component
import CompletePayoutModal from "./CompletePayoutModal"; // Import the new Complete modal component
import { useAllPayouts } from "@hooks/payouts/usePayouts";
import { PayoutContent } from "types/payouts/payoutTypes";
import { updatePayout } from "@services/api/payouts/payoutServices";
import { toast } from "react-toastify";
import arrow from '@images/back.png';

const PayoutTable: React.FC = () => {
  const [selectedPayout, setSelectedPayout] = useState<PayoutContent | null>(null);
  const { data, isLoading, error, refetch } = useAllPayouts();
  const [openmodal, setopenmodal] = useState(false);
  const [completeModal, setcompleteModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1); // State for current page
  const [Loading, setLoading] = useState(false);

  // Set the number of records per page
  const pageSize = 4;

  // Calculate pagination information from the API response
  const totalRecords = data?.content?.length || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // Slice the data for the current page
  const paginatedData = data?.content?.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const closeModal = () => {
    setSelectedPayout(null);
    setopenmodal(false);
  };

  const handleclick = (payout: PayoutContent) => {
    setSelectedPayout(payout);
    setopenmodal(true);
  };

  const handleCompleteclick = (payout: PayoutContent) => {
    setSelectedPayout(payout);
    setcompleteModalOpen(true);
  };

  const handleCompleteSubmit = async (transactionId: string) => {
    console.log("Transaction ID submitted:", transactionId);
    setLoading(true); // Activate loader
    try {
      const res = await updatePayout(String(selectedPayout?.payoutId), {
        status: "COMPLETED",
        bankReferenceId: transactionId,
      });
      if (res) {
        refetch();
        toast.success("Payout Updated Successfully");
        setcompleteModalOpen(false); // Close modal on success
      }
    } catch (error) {
      toast.error("Unable to update Payout");
    } finally {
      setLoading(false); // Deactivate loader after API call
    }
  };

  return (
    <div className="transaction-table-container">
      <table>
        <thead>
          <tr>
            <th>Payout ID</th>
            <th>Food Court Name</th>
            <th>Date and Time</th>
            <th>Payout Amount</th>
            <th>Payout Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {!isLoading ? (
            paginatedData?.map((payout: PayoutContent) => (
              <tr key={payout.payoutId}>
                <td className="orderId">
                  <button
                    onClick={() => handleclick(payout)} // View details handler
                    className="view-details-button"
                  >
                    <span style={{ color: "#42CBDD", textDecoration: "none" }}>
                      {payout.payoutId}
                    </span>
                  </button>
                </td>
                <td>{payout.foodCourtName}</td>
                <td>{payout.payoutDate}</td>
                <td>₹{payout.payoutAmount?.toFixed(2)}</td>
                <td className={`status ${payout.status.toLowerCase()}`}>
                  {payout.status}
                </td>
                <td>
                  {payout.status === "PENDING" ? (
                    <button
                      onClick={() => handleCompleteclick(payout)}
                      className="view-details-button"
                      style={{
                        border: "1px solid #42CBDD",
                        padding: "8px 12px",
                        borderRadius: 4,
                        backgroundColor: "#42CBDD", // Background for pending payouts
                        cursor: "pointer", // Pointer cursor for pending payouts
                      }}
                    >
                      <span
                        style={{
                          color: "white",
                          textDecoration: "none",
                          textTransform: "uppercase",
                          fontSize: 14,
                        }}
                      >
                        Mark as Completed
                      </span>
                    </button>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            ))
          ) : (
            <td>isLoading...</td>
          )}
        </tbody>
      </table>

      {/* Pagination controls */}
      <div className="pagination-controls">
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          <img src={arrow} alt="<" />
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          <img src={arrow} alt=">" style={{ transform: "rotate(180deg)" }} />
        </button>
      </div>

      {/* Ensure selectedPayout is passed to the modal */}
      {selectedPayout && (
        <PayoutDetailsModal
          data={selectedPayout} // Pass the selected payout to the modal
          open={openmodal}
          closeModal={closeModal}
        />
      )}

      {/* Complete Modal */}
      {completeModal && (
        <CompletePayoutModal
          open={completeModal}
          onClose={() => {
            setcompleteModalOpen(false);
            setSelectedPayout(null);
          }}
          onConfirm={handleCompleteSubmit}
          Loading={Loading}
        />
      )}
    </div>
  );
};

export default PayoutTable;
